"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../../../helpers/cssClassesHelper");
var _Modal = _interopRequireDefault(require("../../../../common/Modal/Modal"));
require("./DisableMarginConfirmationModal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('disable-interest-confirmation');
var DisableMarginConfirmationModal = function DisableMarginConfirmationModal(_ref) {
  var close = _ref.close,
    isOpen = _ref.isOpen,
    disable = _ref.disable;
  var _useTranslation = (0, _reactI18next.useTranslation)("user"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: t("Interest Bearing Accounts"),
    close: close,
    footer: {
      buttonText: t("OK"),
      onClick: function onClick() {
        return disable().then(close);
      }
    },
    customClass: bemClasses('modal')
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, t('Are you sure want to turn off interest bearing accounts? ' + 'If you do so, you will have to reapply to begin lending again.')), /*#__PURE__*/_react["default"].createElement("br", null)));
};
DisableMarginConfirmationModal.propTypes = {
  close: _propTypes["default"].func.isRequired,
  isOpen: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = DisableMarginConfirmationModal;